module.exports = __webpack_public_path__ + "static/media/Portrait-10274.9a4ec9a9.jpg";